import React, { memo } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import UpSvg from './styledArrowUp'; // Changed to import default

const ArrowUp = ({ width = 10, height = 5 }) => (
  <UpSvg
    width={width}
    height={height}
    viewBox="0 0 10 5"
    fill="none"
  >
    <path d="M0 5L5 0L10 5H0Z" />
  </UpSvg>
);

ArrowUp.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default memo(ArrowUp);
